import React, { useState } from 'react';
import * as DateFns from 'date-fns';

import TwinSlider from '../Shared/Graphics/TwinSlider';
import { Times } from './types';

type DataOpsTimeSliderProps = {
  times: NewTimesType;
  changeTimes: (times:NewTimesType)=>void;
}
type NewTimesType = {
  first: Date | number,
  second: Date | number
}

export default ({ times, changeTimes }: DataOpsTimeSliderProps) => {
  const [data, setData] = useState({ first: 0, second: 100 });
  const [relativeTime, setRelativeTime] = useState({ first: times.first, second: times.second });
  const diff = DateFns.differenceInMilliseconds(times.second, times.first);
  const changeData = (newData:Times) => {
    setData({ ...newData });
    const newTimes = {
      first: DateFns.addMilliseconds(times.first, ~~((newData.first * diff) / 100)),
      second: DateFns.subMilliseconds(times.second, ~~(((100 - newData.second) * diff) / 100))
    };
    setRelativeTime(newTimes);
    changeTimes(newTimes);
  };
  return (
    <>
      <div className="dataops-edit-entities-retract-time-box">
        <div className="dataops-edit-entities-retract-time-title">Targeted Retrack Time</div>
        <div className="dataops-edit-entities-retract-time-des">Provide timestamp to retrack selected entities.</div>
        <div className="dataops-edit-entities-retract-time-slider">
          <div className="dataops-edit-entities-retract-time-slider-data">
            <div>Start {DateFns.format(relativeTime.first, 'MM/dd/yy HH:mm:ss')}</div>
            <div>End {DateFns.format(relativeTime.second, 'MM/dd/yy HH:mm:ss')}</div>
          </div>
          <div>
            <div style={{ marginLeft: '30px', width: '1112px', height: '35px'}}>
              <TwinSlider data={data} setData={changeData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
